// src/api/referralApi.js
import apiClient from './apiClient';

const referralClient = apiClient('referral');

const referralApi = {
    /**
     * Создать/получить реферальную ссылку для промо (для админки)
     * POST /referral/create-internal
     * Тип: PROMO_PROMOTION (для продвижения промо)
     * @param userId - creatorUserId промо (владелец)
     * @param promoId - ID промо
     */
    async getPromoReferralLink(userId, promoId) {
        const res = await referralClient.post('create-internal', { 
            userId, 
            promoId, 
            referralType: 'PROMO_PROMOTION',
            skipValidation: true 
        });
        return res.data;
    },

    /**
     * Получить статистику по промо (для админа)
     * GET /referral/my/promo/:promoId/stats
     */
    async getPromoStats(promoId) {
        const res = await referralClient.get(`my/promo/${promoId}/stats`);
        return res.data;
    },

    /**
     * Admin: получить сводку по пользователю
     * GET /referral/admin/user/:userId/summary
     */
    async adminUserSummary(userId) {
        const res = await referralClient.get(`admin/user/${userId}/summary`);
        return res.data;
    },

    /**
     * Admin: регенерировать ссылку пользователю
     * PUT /referral/admin/user/:userId/regenerate
     */
    async adminRegenerate(userId) {
        const res = await referralClient.put(`admin/user/${userId}/regenerate`);
        return res.data;
    },
};

export default referralApi;
